import { connect } from 'react-redux';
import Security from './Security';
import { resetPasswordRequest } from '../../../store/actions/user.actions';
import { passwordLoading, getError } from '../../../store/selectors/user.selector';

const mapDispatchToProps = { resetPasswordRequest };

const mapStateToProps = (state) => { 
    let loading = passwordLoading(state);
    let error = getError(state);

    return { loading, error };
 };


export default connect(mapStateToProps, mapDispatchToProps)(Security);